import { useState } from "react";
import { bool } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useEstimateEditorStore, useEstimateStructure } from "@tools";
import { CurrencyEditor } from "@dialogs";
import { Alert } from "@components";

export const EstimateCurrencyEditor = observer(({
  useCompanyCurrency
}) => {
  const { t } = useTranslation();
  const editorStore = useEstimateEditorStore();
  const structure = useEstimateStructure();
  
  const [ selectedCurrency, setSelectedCurrency ] = useState(null);
  const [ isLoading, setLoading ] = useState(null);
  
  const handleSetCurrency = async (data) => {
    if(useCompanyCurrency)
      setCurrency(data.code);
    else
      setSelectedCurrency(data.code);
  }
  
  const handleAlertChoice = (convert) => async () => {
    setLoading(true);
    await setCurrency(selectedCurrency, convert);
    setLoading(false);
    setSelectedCurrency(null);
  }

  const setCurrency = async (code, convert) => {
    structure.historyManager.startGroup();
    const v = [
      structure.settings.companyCurrency,
      structure.settings.currency
    ];
    
    v[useCompanyCurrency ? 0 : 1] = code;
    
    if(convert) {
      const rates = await editorStore.getExchangeRates(structure.settings.currency, code);
      structure.convertExistingRatesToCurrency(rates, structure.settings.currency, code);
    }
    
    if(useCompanyCurrency)
      structure.settings.setCompanyCurrency(v[0]);
    else
      structure.settings.setCurrency(v[1]);
    
    if(editorStore.profitabilityMode) {
      if(v[0] === v[1])
        structure.settings.setDefaultDailyExchangeRate(new Date().getTime());
      else try {
        const rates = await editorStore.getExchangeRates(...v);
        structure.settings.setDailyExchangeRate(rates);
      } catch(e) {
        structure.settings.setDefaultDailyExchangeRate();
      }
    }
    
    structure.historyManager.stopGroup();
  };

  const { currency, companyCurrency } = structure.settings;

  return <>
    <CurrencyEditor
      currency={useCompanyCurrency ? companyCurrency : currency}
      onChange={handleSetCurrency}
      absolute
    />
    <Alert
      width={468}
      isOpen={Boolean(selectedCurrency)}
      title={t("views.editor.dialogs.sales_currency_alert.title", { selectedCurrency })}
      onCancel={handleAlertChoice(false)}
      onAccept={handleAlertChoice(true)}
      isAcceptLoading={isLoading}
      acceptText={t("views.editor.dialogs.sales_currency_alert.accept", { selectedCurrency })}
      cancelText={t("views.editor.dialogs.sales_currency_alert.cancel")}
    />
  </>
});

EstimateCurrencyEditor.propTypes = {
  useCompanyCurrency: bool
}